import { Component, ViewChild } from '@angular/core';
import { NavController, Searchbar, Keyboard } from 'ionic-angular';
import { Subscription, Observable } from 'rxjs';
import { Chapter } from '../../models/Chapter';
import { Entry } from '../../models/entry';
import { Api } from '../../providers/api';
import { PostSearchResponseItem } from '../../providers/api/responses/PostSearchResponse';
import { DirectoryService } from '../../providers/directory-service';
import { RecentSearchService } from '../../providers/recent-search-service';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { ContentBlock } from '../../models/content-block';
import { ErrorResponse } from '../../providers/api/responses/ErrorResponse';
import { DesktopService } from "../../providers/desktop-service";

@Component({
    selector: 'page-search-directory',
    templateUrl: 'search-directory.html'
})

export class SearchDirectoryPage {

    @ViewChild('searchBar') public searchBar: Searchbar;

    public displayMode: ('bookmarks' | 'recents' | 'results') = 'recents';

    public isSearching: boolean = false;
    public searchBarBlur: Subscription;
    public searchBarChange: Subscription;
    public searchBarClear: Subscription;
    public searchBarFocus: Subscription;
    public searchBarReturn: Subscription;
    public searchResults: PostSearchResponseItem[];
    public searchError: string = null;
    public recentSearches: string[] = [];

    constructor(
        public analytics: FirebaseAnalytics,
        public api: Api,
        public directoryService: DirectoryService,
        public keyboard: Keyboard,
        public navCtrl: NavController,
        public recentSearchService: RecentSearchService,
        private desktopService: DesktopService,
    ) {
        const updateRecentSearches = (searches: string[]) => { this.recentSearches = searches.reverse(); };

        this.recentSearchService.getAll().then(updateRecentSearches);
        this.recentSearchService.watch().subscribe(updateRecentSearches);
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Search');
    }

    public async ngAfterViewInit() {
        this.searchBarClear = this.searchBar.ionClear.subscribe(() => {
            this.searchResults = null;
            this.displayMode = 'recents';
            this.searchBar.setFocus();
        });

        let searchBarElement: HTMLElement = this.searchBar.getNativeElement();
        this.searchBarReturn = Observable.fromEvent(searchBarElement, 'keypress').subscribe((event: KeyboardEvent) => {
            if (event.charCode == 13) {
                this.displayMode = 'results';
                this.performSearch();
            }
        });

        this.searchBarFocus = this.searchBar.ionFocus.subscribe(() => {
            if (this.searchResults && this.searchResults.length > 0) return;
            if (this.searchBar.hasValue()) this.displayMode = 'results';
            else this.displayMode = 'recents';
        });
    }

    public ngOnDestroy() {
        if (this.searchBarChange && !this.searchBarChange.closed) this.searchBarChange.unsubscribe();
        if (this.searchBarClear && !this.searchBarClear.closed) this.searchBarClear.unsubscribe();
        if (this.searchBarFocus && !this.searchBarFocus.closed) this.searchBarFocus.unsubscribe();
        if (this.searchBarReturn && !this.searchBarReturn.closed) this.searchBarReturn.unsubscribe();
    }

    public getParentsForEntry(entry: Entry) {
        let parents = [];

        for (let parent of entry.parents) {
            parents.push(parent.title);
        }

        return parents.length > 0 ? parents.reverse() : null;
    }

    public performSearch() {
        let searchTerm = this.searchBar.value;
        this.isSearching = true;

        this.analytics.logEvent('search', {
            search_term: searchTerm,
        });

        this.api.postSearch({
            search: searchTerm
        })
            .finally(() => this.isSearching = false)
            .subscribe(results => {
                this.searchResults = results;

                if (!results || results.length < 1) this.searchError = 'Sorry, but no results were found.';
                else {
                    this.searchError = null;
                    this.recentSearchService.add(searchTerm);
                    this.keyboard.close();
                }
            }, error => {
                if (error instanceof ErrorResponse) {
                    switch (error.code) {
                        case 0:
                            this.searchError = `<p><b>A error occured while searching.</p></b><p>Please make sure you have
                                an active internet connection and try again.</p>`;
                            break;
                        case 500:
                        default:
                            this.searchError = `<p><b>A error occured while searching.</p></b><p>This is most likely
                                a temporary issue.<br/>Please try again later.</p><p>
                                <small>Server Error: ${error.code}</small></p>`;
                            break;
                    }
                } else {
                    this.searchError = `<p>A unknown error occured while searching.</p><p>Please make sure you have an active
                        internet connection and try again.</p>`;
                }
            });
    }

    public async showContentBlock(contentBlock: ContentBlock) {
        this.showEntry(contentBlock.entry);
    }

    public async showChapter(chapter: Chapter) {
        this.directoryService.showChapter(chapter);
    }

    public async showEntry(entry: Entry) {
        this.directoryService.showEntry(entry);
    }

    public selectRecentSearch(text: string) {
        this.searchBar.setValue(text);
        this.displayMode = 'results';
        this.performSearch();
    }

}



// WEBPACK FOOTER //
// ./src/pages/search-directory/search-directory.ts